import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { EMAILS } from "@/lib/emails";

export default function Footer() {
  return (
    <footer className="mt-20" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="glass-card px-8 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-orange-500 to-orange-400 text-white grid place-items-center font-bold">F</div>
              <span className="font-bold">fodindin</span>
            </div>
            <p className="text-sm text-[var(--ink-soft)]">
              La plateforme premium de petites annonces en Cote d'Ivoire.
            </p>
            <a
              href={`mailto:${EMAILS.contact}`}
              className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-orange-600"
              data-testid="footer-mailto-contact"
            >
              <Mail size={14} /> {EMAILS.contact}
            </a>
          </div>
          <div>
            <div className="font-bold mb-3">Navigation</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/annonces" className="footer-link">Annonces</Link></li>
              <li><Link to="/hotelleries" className="footer-link">Hotelleries</Link></li>
              <li><Link to="/favoris" className="footer-link">Favoris</Link></li>
              <li><Link to="/dashboard" className="footer-link">Dashboard</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-bold mb-3">Services</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/deposer" className="footer-link">Deposer une annonce</Link></li>
              <li><Link to="/favoris" className="footer-link">Mes favoris</Link></li>
              <li><Link to="/abonnements" className="footer-link">Abonnements</Link></li>
              <li><Link to="/contact" className="footer-link" data-testid="footer-link-contact">Nous contacter</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-bold mb-3">Contact</div>
            <ul className="space-y-2 text-sm">
              <li>
                <a href={`mailto:${EMAILS.support}`} className="footer-link" data-testid="footer-mailto-support">
                  Support : {EMAILS.support}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAILS.partenariats}`} className="footer-link" data-testid="footer-mailto-partenariats">
                  Partenariats : {EMAILS.partenariats}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAILS.marketing}`} className="footer-link" data-testid="footer-mailto-marketing">
                  Marketing : {EMAILS.marketing}
                </a>
              </li>
              <li><Link to="/confiance-securite" className="footer-link" data-testid="footer-link-securite">Confiance & Sécurité</Link></li>
              <li><Link to="/confidentialite" className="footer-link" data-testid="footer-link-confidentialite">Politique de confidentialité</Link></li>
              <li><Link to="/faq-paiements" className="footer-link">FAQ Paiements sécurisés</Link></li>
              <li><Link to="/cgu" className="footer-link">CGU & non-responsabilite</Link></li>
            </ul>
          </div>
        </div>
        <div className="text-center text-xs text-[var(--ink-soft)] py-6">
          © {new Date().getFullYear()} fodindin — Marketplace premium en Cote d'Ivoire
        </div>
      </div>
    </footer>
  );
}
